if (!customElements.get('funkids-category-menu')) {
  customElements.define('funkids-category-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.details = this.closest('details');
      this.header = this.closest('.section-header');
      this.template = this.template || this.querySelector('template[data-category-menu]');
      this.frame = null;
      this.listening = false;
      this.position = null;
      this.schedulePosition = () => {
        if (!this.listening || this.frame !== null) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          if (!this.listening || !this.header) return;
          const position = Math.max(0, Math.round(this.header.getBoundingClientRect().bottom));
          if (position !== this.position) {
            this.style.setProperty('--all-cat-top', `${position}px`);
            this.position = position;
          }
        });
      };
      this.sync = () => {
        if (this.desktop.matches && this.template?.isConnected) {
          this.template.replaceWith(this.template.content);
        } else if (!this.desktop.matches && this.template && !this.template.isConnected) {
          const content = this.querySelector(':scope > .page-width');
          if (content) {
            content.replaceWith(this.template);
            this.template.content.append(content);
          }
        }
        const shouldListen = this.desktop.matches && Boolean(this.details?.open);
        if (shouldListen && !this.listening) {
          this.listening = true;
          window.addEventListener('scroll', this.schedulePosition, { passive: true });
          window.addEventListener('resize', this.schedulePosition, { passive: true });
          if ('ResizeObserver' in window && this.header) {
            this.observer = new ResizeObserver(this.schedulePosition);
            this.observer.observe(this.header);
          }
        } else if (!shouldListen) {
          this.stopListening();
        }
        this.schedulePosition();
      };
      this.desktop.addEventListener('change', this.sync, { signal: this.controller.signal });
      this.details?.addEventListener('toggle', this.sync, { signal: this.controller.signal });
      this.sync();
    }

    stopListening() {
      this.listening = false;
      window.removeEventListener('scroll', this.schedulePosition);
      window.removeEventListener('resize', this.schedulePosition);
      this.observer?.disconnect();
      this.observer = null;
      if (this.frame !== null) cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    disconnectedCallback() {
      this.stopListening();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
